import React, { FC } from 'react'

import styled from 'styled-components'

export const ProfileAge: FC<{ age: number }> = ({ age }) => {
  return <Age data-name="item-title-age">, {age}</Age>
}

const Age = styled.span`
  white-space: nowrap;
`
